(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('historicoTarefas', HistoricoTarefas);

  function HistoricoTarefas() {
    return {
      restrict: 'E',
      templateUrl: 'views/propriedade/historico-tarefas.html',
      controller: 'HistoricoTarefasCtrl',
      controllerAs: 'tarefas'
    };
  }

}());
